import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import IUser from "../types/user";
import {setErrorAction} from "../store/reducers/commonSlice";
import {setCredentialsAction, removeCredentialsAction, setTokenAction} from "../store/reducers/authSlice";
import {AuthService} from "../services/AuthService";
import endpoints from "../endpoints";

interface ILoginRequest {
    username: string
    password: string
}

interface ILoginResponse {
    access_token: string
}

// interface IValidateResponse {
//     user: IUser
// }

export const authAPI = createApi({
    reducerPath: 'authAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: `${endpoints.api}/auth`,
        prepareHeaders: (headers: Headers) => {
            const token = AuthService.getToken() || ''
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
        }
    }),
    endpoints: (builder) => ({
        login: builder.mutation<ILoginResponse, ILoginRequest>({
            query: (loginData) => {
                return {
                    url: '/login',
                    method: 'POST',
                    body: loginData
                }
            },
            async onQueryStarted(id, {dispatch, queryFulfilled}) {
                try {
                    const {data, meta} = await queryFulfilled
                    if (!data.access_token) {
                        dispatch(setErrorAction('Authorization error'))
                        dispatch(removeCredentialsAction())
                        return;
                    }

                    dispatch(setTokenAction(data.access_token))

                } catch(e) {
                    dispatch(setErrorAction('Authorization error'))
                    dispatch(removeCredentialsAction())
                    return;
                }
            }
        }),
        validate: builder.mutation<any, void>({
            query: (token) => {
                return {
                    url: '/profile',
                    method: 'POST'
                }
            },
            async onQueryStarted(token, {dispatch, queryFulfilled}) {
                try {
                    const {data, meta} = await queryFulfilled

                    if (!data.id) {
                        dispatch(removeCredentialsAction())
                        return;
                    }

                    dispatch(setCredentialsAction({
                        authUser: {...data}
                    }))

                } catch(e) {
                    dispatch(removeCredentialsAction())
                    return;
                }
            }
        })
    })
})